import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, T4CCService } from 't4core';
import { T4ListItem } from '../../../../../projects/t4core/src/public-api';
import { Pricelists } from '../../Views/Pricelists/Pricelists';
import { map } from 'rxjs';

@Component({
  selector: 'GroupMappingDialog',
  templateUrl: 'GroupMappingDialog.html',
  styleUrls: ['./GroupMappingDialog.css']
})
export class GroupMappingDialogComponent extends DialogBase {


  public loading: boolean = false;
  public loadingSaving: boolean = false;


  public pristLists: any[] = [];
  public currentMappings: any[] = [];
  public groups: T4ListItem[] = [];

  public selectedGroupId: any = null;
  public selectedPriceListTitle: string | null = null;

  public mappingsForSelectedGroup: any[] = [];
  public mappingsForSelectedPriceList: any[] = [];
  public selectedMappingExists: boolean | null = null;

  public availablePriceLists: any[] = [];

  public errorSaving: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<GroupMappingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private svc: T4CCService
  ) {
    super("GroupMappingDialogComponent");

  }

  public async ngOnInit() {

    this.loading = true;

    this.pristLists = this.data;
    this.currentMappings = await this.Api.get<any[]>("TurboOrder/GetGroupMappings");
    this.groups = await this.Api.get<T4ListItem[]>("TurboOrder/GetAllGroups");
 
    this.recomputeSelectionState();
    this.loading = false;
  }

  public onGroupSelectionChanged(): void {
    this.recomputeSelectionState();
  
  }

  public onPriceListSelectionChanged(): void {
    this.recomputeSelectionState();
  
  }

  private recomputeSelectionState(): void {
    const groupId = this.selectedGroupId;
    const priceListTitle = this.selectedPriceListTitle;

    const usedChains = new Set(
      (this.currentMappings ?? [])
        .map(m => this.getMappingPriceListTitle(m)?.toLowerCase())
        .filter(Boolean)
    );

    this.availablePriceLists = groupId == null
      ? (this.pristLists ?? [])
      : (this.pristLists ?? []).filter(pl =>
        !usedChains.has(pl.Title?.toLowerCase())
      );

    const selectedPriceListStillAvailable =
      priceListTitle == null ||
      this.availablePriceLists.some(pl =>
        pl.Title?.toLowerCase() === priceListTitle.toLowerCase()
      );

    if (!selectedPriceListStillAvailable) {
      this.selectedPriceListTitle = null;
    }

    this.mappingsForSelectedGroup = groupId == null
      ? []
      : (this.currentMappings ?? [])
        .filter(m => this.getMappingGroupId(m) == groupId)
        .map(m => {
          const priceList = (this.pristLists ?? []).find(
            pl => pl.Title?.toLowerCase() == m.Chain?.toLowerCase()
          );

          return {
            ...m,
            PriceListId: priceList?.Id ?? null
          };
        });

    this.mappingsForSelectedPriceList = priceListTitle == null
      ? []
      : (this.currentMappings ?? [])
        .filter(m => this.getMappingPriceListTitle(m)?.toLowerCase() == priceListTitle.toLowerCase())
        .map(m => {
          const mappedGroupId = this.getMappingGroupId(m);
          const group = (this.groups ?? []).find(g => g.Id == mappedGroupId.toString());

          return {
            ...m,
            GroupName: group?.Name ?? null
          };
        });

    if (groupId == null || priceListTitle == null) {
      this.selectedMappingExists = null;
      return;
    }

    this.selectedMappingExists = (this.currentMappings ?? []).some(m =>
      this.getMappingGroupId(m) == groupId &&
      this.getMappingPriceListTitle(m)?.toLowerCase() == priceListTitle.toLowerCase()
    );
  }

  private getMappingGroupId(mapping: any): number | null {
    return mapping?.T4GroupId ?? null;
  }

  private getMappingPriceListTitle(mapping: any): string | null {
    return mapping?.Chain ?? null;
  }



  public async createMapping() {
    this.loadingSaving = true;

    if (this.selectedMappingExists || this.selectedGroupId == null || this.selectedPriceListTitle == "") return false;

    var res = await this.Api.get<boolean>("TurboOrder/CreateGroupMapping", { groupId: this.selectedGroupId, priceList: this.selectedPriceListTitle })

    if (res) {
      this.UI.snackBarLocal('Turbo.Order.GroupMapping.snackBarConfirmCreate', 'Mapping have been created.')
      this.loadingSaving = false;
      this.dialogRef.close();
    }
    else {
      this.errorSaving = true;
    }

    this.loadingSaving = false;

  }

  public async removeMappingPrieList(mapping: any) {

    var x = await this.UI.confirm("Turbo.Order.GroupMapping.ConfirmDeletion", "Confirm deletion of mapping", "Turbo.Order.GroupMapping.msgConfirmDeletion", "This will remove the mapping between the group and pricelist. Do you wish to continue?");
    if (x) {
      var res = await this.Api.delete<boolean>("TurboOrder/DeleteGroupMapping", { groupId: mapping.T4GroupId, priceList: mapping.Chain })

      if (res) {
        this.UI.snackBarLocal('Turbo.Order.GroupMapping.snackBarConfirmCreate', 'Created mapping.')
        this.dialogRef.close();
      }
    }
    else {
      this.UI.snackBarLocal('Turbo.Order.GroupMapping.snackBarCreateFailed', 'Failed to create mapping.')
    }
  }

  public async removeMappingGroup(mapping: any) {

    var x = await this.UI.confirm("Turbo.Order.GroupMapping.ConfirmDeletion", "Confirm deletion of mapping", "Turbo.Order.GroupMapping.msgConfirmDeletion", "This will remove the mapping between the group and pricelist. Do you wish to continue?");
    if (x) {
      var res = await this.Api.get<boolean>("TurboOrder/DeleteGroupMapping", { groupId: mapping.T4GroupId, priceList: mapping.Chain })

      if (res) {
        this.UI.snackBarLocal('Turbo.Order.GroupMapping.snackBarConfirmDeletion', 'Deleted mapping.')
        this.dialogRef.close();
      }
    }
    else {
      this.UI.snackBarLocal('Turbo.Order.GroupMapping.snackBarDeleteFailed', 'Failed to delete mapping.')
    }
  }

}
